<template lang="pug">
  .agreements
    article.agreement(v-for="(ra,idx) in registration.agreements()")
      .content
        .title {{ra.agreement.name}}
        div(v-html="external_links($sanitize(ra.agreement.description))" v-linkified)
        .fields
          .row
              span.agreement-alert-label(v-if="!ra.agreement.must_agree")
                | {{t('app.registration.agreement.please_make_a_selection')}}
                span.required *
          .row
            validation-provider(v-slot="{ errors }" :rules="{required: !disabled(ra)}")
              div(v-if="ra.agreement.must_agree")
                  .form-col.large-10
                    .field.checkbox-field2
                      label(:for="'first_accepted'+idx" :class="{error: errors[0]}")
                        input.no-custom(type="checkbox",v-model="ra.first_accepted",:id="'first_accepted'+idx" :disabled="disabled(ra)",:required="!disabled(ra)")
                        span.label-text
                          | {{t('app.registration.agreements_agree')}}
                          span.required *
              div(v-else="")
                  .form-col.large-5
                    .field.checkbox-field2
                      label(:for="'first_accepted'+idx+'agree'" :class="{error: errors[0]}")
                        input.no-custom(type="radio",v-model="ra.first_accepted",:value="true",:id="'first_accepted'+idx+'agree'" :disabled="disabled(ra)",:required="!disabled(ra)")
                        span.label-text
                          | {{t('app.registration.agreements_agree')}}
                  .form-col.large-5
                    .field.checkbox-field2
                      label(:for="'first_accepted'+idx+'disagree'" :class="{error: errors[0]}")
                        input.no-custom(type="radio",v-model="ra.first_accepted",:value="false",:id="'first_accepted'+idx+'disagree'" :disabled="disabled(ra)",:required="!disabled(ra)")
                        span.label-text
                          | {{t('app.registration.agreements_disagree')}}
            validation-provider(slim v-slot="{ errors }" :rules="{required: !disabled(ra) && (ra.agreement.must_agree||ra.first_accepted)}")
                .form-col.large-14
                  .row
                    .form-col.large-12
                      label.inline.right(:class="{error: errors[0]}")
                        | {{t('app.registration.agreements_field_name')}}
                        span.required *
                    .form-col.large-12
                      .field
                        FloatingLabel(:config="{label: t('app.registration.agreements_name'), required: !disabled(ra) && ra.agreement.must_agree}")
                          input(type="text" v-model="ra.first_name",:placeholder="t('app.registration.agreements_name')",:disabled="disabled(ra)",:required="!disabled(ra) && (ra.agreement.must_agree || ra.first_accepted !== null)" :class="{error: errors[0]}" autocomplete="new-password")
                        validation-provider(:name="'first-parent-input-'+ ra.agreement_id" v-slot="{ errors }")
                          span.error(v-if="errors[0]") {{ 'The signature does not match the name we have on file' }}
                      label
                        span.label-text
                          | {{t("helpers.label.agreement.signature_types."+(ra.agreement.first_signature_type || 'older_than'))}}
                          
          div(v-if="isPresent(ra.agreement.second_signature_type)")
            br
            .row
              span.agreement-alert-label(v-if="!ra.agreement.must_agree")
                  | {{t('app.registration.agreement.please_make_a_selection')}}
                  span.required *
            .row
              validation-provider(slim v-slot="{ errors }" :rules="{required: !disabled(ra)}")
                  div(v-if="ra.agreement.must_agree")
                    .form-col.large-10
                      .field.checkbox-field2
                        label(:class="{error: errors[0]}")
                          input.no-custom(type="checkbox",v-model="ra.second_accepted",:id="'second_accepted'+idx" :disabled="disabled(ra)",:required="!disabled(ra)")
                          span.label-text
                            | {{t('app.registration.agreements_agree')}}
                            span.required *
                  div(v-else="")
                    .form-col.large-5
                      .field.checkbox-field2
                        label(:for="'second_accepted'+idx+'agree'" :class="{error: errors[0]}")
                          input.no-custom(type="radio",v-model="ra.second_accepted",:value="true",:id="'second_accepted'+idx+'agree'" :disabled="disabled(ra)",:required="!disabled(ra)")
                          span.label-text
                            | {{t('app.registration.agreements_agree')}}
                    .form-col.large-5
                      .field.checkbox-field2
                        label(:for="'second_accepted'+idx+'disagree'" :class="{error: errors[0]}")
                          input.no-custom(type="radio",v-model="ra.second_accepted",:value="false",:id="'second_accepted'+idx+'disagree'" :disabled="disabled(ra)",:required="!disabled(ra)")
                          span.label-text
                            | {{t('app.registration.agreements_disagree')}}
              validation-provider(slim v-slot="{ errors }" :rules="{required: !disabled(ra) && (ra.agreement.must_agree||ra.second_accepted)}")
                  .form-col.large-14
                    .row
                      .form-col.large-12
                        label.inline.right(:class="{error: errors[0]}")
                          | {{t('app.registration.agreements_field_name')}}
                          span.required *
                      .form-col.large-12
                        .field
                          FloatingLabel(:config="{label: t('app.registration.agreements_name'), required: !disabled(ra) && ra.agreement.must_agree}")
                            input(type="text",v-model="ra.second_name",:placeholder="t('app.registration.agreements_name')",:disabled="disabled(ra)",:required="!disabled(ra) && (ra.agreement.must_agree || ra.first_accepted !== null)" :class="{error: errors[0]}" autocomplete="new-password")
                          validation-provider(:name="'second-parent-input-'+ ra.agreement_id" v-slot="{ errors }")
                            span.error(v-if="errors[0]") {{ 'The signature does not match the name we have on file' }}
                        label
                          span.label-text {{t("helpers.label.agreement.signature_types."+ra.agreement.second_signature_type)}}
</template>
<script>
  export default {
    created(){
      this.disabled_cache = {}
    },
    methods: {
      disabled(reg_agreement){
        if (!this.disabled_cache[reg_agreement.id]) {
          this.disabled_cache[reg_agreement.id] = this.calcDisabled(reg_agreement)
        }
        return this.disabled_cache[reg_agreement.id]
      },
      //ONLY FOR EDIT REG. Editing agreement is blocked, unless this is new agreement, or we are in correction required. It's blocked for org editing tempuser also
      calcDisabled(registration_agreement){
        return (registration_agreement.id && !this.registration.isStillPending()) && !this.registration.isCorrectionRequired()
      }
    },
    computed: {
      registration(){
        return this.state.current_reg
      },
    },
  }
</script>
